export const DETAILED_VIEW_MODAL_SHOW = "DETAILED_VIEW_MODAL_SHOW";

export const DETAILED_VIEW_MODAL_HIDE = "DETAILED_VIEW_MODAL_HIDE";

const ALL = {
  DETAILED_VIEW_MODAL_SHOW,
  DETAILED_VIEW_MODAL_HIDE,
};
export default ALL;
